import {
  GET_CLIENT_CAMPAIGN_FULFILLMENT,
  GET_CLIENT_CAMPAIGN_FULFILLMENT_ERROR,
  GET_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS,
  EXPORT_CLIENT_CAMPAIGN_FULFILLMENT,
  EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS,
  EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_ERROR,
} from "./actionTypes"
import { handleGetCampaignFulfillment, handleGetCampaignFulfillmentError, handleGetCampaignFulfillmentSuccess } from "helpers/campaign_fulfillment_pagination_helper"

const initialState = {
  error: null,
  client_campaign_fulfillment: [],
  loading: null,
  export_loading: false,
  has_next_page: false,
  last_page_fetched: 0,
  has_lookahead_pages: false,
  total_number_of_pages: 0,
  active_cache_key: null,
  page_cache: {},
  last_fetched_at: null,
}

const ClientCampaignFulfillment = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_CAMPAIGN_FULFILLMENT:
      return handleGetCampaignFulfillment(state, action, 'client_campaign_fulfillment')
    case GET_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS:
      return handleGetCampaignFulfillmentSuccess(state, action, 'client_campaign_fulfillment')

    case GET_CLIENT_CAMPAIGN_FULFILLMENT_ERROR:
      return handleGetCampaignFulfillmentError(state, action, 'client_campaign_fulfillment')

    case EXPORT_CLIENT_CAMPAIGN_FULFILLMENT:
      return { ...state, export_loading: true, error: null }
    case EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS:
      return { ...state, export_loading: false, error: null }
    case EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_ERROR:
      return { ...state, export_loading: false, error: action.payload }
    default:
      return state
  }
}

export default ClientCampaignFulfillment
